/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RestaurantServiceValues {
  Lunch = 'Lunch',
  Dinner = 'Dinner',
  Night = 'Night',
}
